import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheConsultantTransformationDigitale = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧭 Recruter un Consultant en Transformation Digitale
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Consultant en Transformation Digitale accompagne les entreprises dans l’évolution de leurs outils, processus et modèles vers le numérique. Il intervient à la croisée de la stratégie, du changement organisationnel et de l’innovation technologique. Son rôle est d’identifier les leviers de performance digitale et de piloter leur mise en œuvre, tout en fédérant les parties prenantes.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Diagnostiquer la maturité digitale d’une entreprise</li>
          <li>Définir une roadmap de transformation alignée avec les objectifs stratégiques</li>
          <li>Accompagner le choix et le déploiement d’outils numériques (ERP, CRM, SaaS, etc.)</li>
          <li>Superviser la conduite du changement (formation, adoption, gouvernance)</li>
          <li>Identifier les opportunités d’automatisation, de data valorisation et d’optimisation métier</li>
          <li>Piloter des projets transverses avec les directions métier, IT et RH</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Vision stratégique, compréhension des enjeux business et technologiques</li>
          <li>Connaissance des solutions digitales (cloud, IA, data, outils collaboratifs…)</li>
          <li>Expérience en gestion de projet et conduite du changement</li>
          <li>Capacité à dialoguer avec des interlocuteurs variés (DG, DSI, métiers)</li>
          <li>Méthodes : Agile, Lean, Design Thinking, ITIL</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Confirmé : expérience significative dans la mise en œuvre de projets digitaux</li>
          <li>Senior : maîtrise des environnements complexes, rôle de conseil de haut niveau</li>
          <li>Secteur spécifique : retail, finance, industrie, santé, public…</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Confirmé : 500–700 € / jour</li>
          <li>Senior / Expert : 750–1 000 € / jour, voire plus selon le niveau d’accompagnement stratégique</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheConsultantTransformationDigitale;
